import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Optional,
    Output,
} from '@angular/core';

import { TaskComponent } from '../task/task.component';
import { TranslationKeyMap } from '../task/task.component.i18n';

@Component({
    selector: 'cmps-task-list-task-marker',
    templateUrl: './task-marker.component.html',
})
export class TaskMarkerComponent implements OnDestroy {
    @Input() completed: boolean;
    @Output() click: EventEmitter<void>;

    /** @private */
    _i18n = TranslationKeyMap;

    constructor(/** @private */ @Optional() readonly _task: TaskComponent) {
        this.click = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.click.complete();
    }
}
